import anime from "animejs"
import $ from "jquery"

export default {
  name: "Navigation",
  data() {
    return {
      hamOpen: false
    }
  },
  methods: {
    workPageRd() {
      this.$router.push('/home/workShowcase')
    },
    homeRD() {
      this.$router.push('/home')
    },
    hamClick() {
      this.hamOpen = !this.hamOpen
      let linksWrap = document.querySelector(".links")
      let links = document.querySelectorAll(".routerLink")
      let linksWidth = $(window).width() < 768 ? '70vw' : '30vw'

      if (this.hamOpen) {
        anime({
          targets: '.T',
          opacity: 0,
          duration: 0
        })
        anime({
          targets: '.M',
          duration: 400,
          rotate: '-45deg',
          easing: 'easeOutQuad'
        })
        anime({
          targets: '.B',
          translateY: '-.8rem',
          duration: 400,
          rotate: '45deg',
          easing: 'easeOutQuad'
        })


        anime.timeline({
          duration: 800,
        })
          .add({
            targets: linksWrap,
            width: [0, linksWidth],

            begin: function () {
              linksWrap.style.display = 'flex'
            },
          })
          .add({
            targets: links,
            opacity: [0, 1],
            delay: (elm, i) => i * 100,
          }, '-=500')
      } else {
        anime.timeline({
          duration: 700,
        })
          .add({
            targets: '.M',
            duration: 300,
            rotate: '0deg',
            easing: 'easeOutQuad',
          })
          .add({
            targets: '.B',
            translateY: '0rem',
            duration: 300,
            rotate: '0deg',
            easing: 'easeOutQuad',
          }, '-=400')
          .add({
            targets: links,
            opacity: [1, 0],
            duration: 500,
            function() {
              links.forEach(link => {
                link.style.display = 'none'
              })
            },
          }, '-=400')
          .add({
            targets: linksWrap,
            width: [linksWidth, 0],
            duration: 500,
            function() {
              linksWrap.style.display = 'none'
            },
          }, '-=300')
          .add({
            targets: '.T',
            width: [0, '70%'],
            opacity: 1,
            duration: 400,
          }, '-=250')
      }
    }
  },
  watch: {
    hamOpen() {
      document.querySelector("html").style.overflowY = (this.hamOpen) ? "hidden" : "scroll"

      let hamburger = document.querySelector(".hamburger")
      let lines = Array.from(hamburger.children)

      hamburger.addEventListener('mouseover', () => {
        document.querySelector('.T').style.width = '100%'
        lines.forEach(line => {
          line.style.backgroundColor = '#303030'
        })
      })

      hamburger.addEventListener('mouseout', () => {
        document.querySelector('.T').style.width = (this.hamOpen) ? "70%" : " 70%"
        lines.forEach(line => {
          line.style.backgroundColor = (this.hamOpen) ? "#FFF" : " #B2B7BF"
        })
      })

      lines.forEach(line => {
        line.style.backgroundColor = (this.hamOpen) ? "#FFF" : " #B2B7BF"
      })

    }
  },
}